<div class="gu-roles-dialog">
  <div class="gu-dialog__header">
    <span class="gu-dialog__title">
      {{ 'USUARIOS.ROLES_TITLE' | translate:{nombre: data.usuario.nombre, apellido: data.usuario.apellido1} }}
    </span>
    <button type="button" class="gu-icon-btn" (click)="cancel()" [attr.aria-label]="'COMMON.CLOSE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="gu-dialog__body">
    <div class="gu-section-label">{{ 'USUARIOS.ROLES_AVAILABLE' | translate }}</div>

    <div class="gu-roles-list">
      <div
        *ngFor="let rol of data.rolesDisponibles"
        class="gu-rol-row"
        [class.gu-rol-row--selected]="isSelected(rol.id)"
        (click)="toggle(rol.id)"
      >
        <span class="gu-rol-check" [class.gu-rol-check--on]="isSelected(rol.id)">
          <mat-icon *ngIf="isSelected(rol.id)">check</mat-icon>
        </span>
        <span class="gu-rol-name">{{ rol.nombre }}</span>
      </div>
    </div>

    <div class="gu-field-hint" *ngIf="selected.size === 0">
      {{ 'USUARIOS.ROLES_MIN_HINT' | translate }}
    </div>
  </div>

  <div class="gu-dialog__footer">
    <button type="button" class="gu-btn gu-btn--ghost" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="button" class="gu-btn gu-btn--primary" [disabled]="selected.size === 0" (click)="save()">
      <mat-icon>check</mat-icon> {{ 'USUARIOS.SAVE_ROLES' | translate }}
    </button>
  </div>
</div>
